import { graphql } from "@acto/gql";
import { useMemo } from "react";
import { PaginatedDataAccessResult } from "@acto/taskpane/core/data-access/types";
import { usePagination } from "@acto/taskpane/core/data-access/pagination/usePagination";
import { Customer } from "@acto/taskpane/core/domain";
import { mapClientToCustomer } from "./mapClientToCustomer";

const RecommendedClientsQuery = graphql(`
  query GetRecommendedClients($first: Int!, $after: String) {
    recommendedClients(first: $first, after: $after) {
      __typename
      edges {
        __typename
        cursor
        node {
          ...ClientForDetailsWithRecommendedObservation
        }
      }
      pageInfo {
        __typename
        hasNextPage
        endCursor
      }
    }
  }
`);

interface Options {
  limit?: number;
  enabled?: boolean;
}

export function useRecommendedClients({
  limit = 5,
  enabled = true,
}: Options = {}): PaginatedDataAccessResult<Customer> {
  const { data, isFetching, isPending, error, hasNextPage, fetchNextPage, refreshAfter } = usePagination({
    query: RecommendedClientsQuery,
    limit,
    enabled,
    connection: (data) => data.recommendedClients,
  });

  const customers = useMemo(() => data?.map(mapClientToCustomer), [data]);

  return {
    data: customers,
    isFetching,
    isPending,
    error,
    hasNextPage,
    fetchNextPage,
    refreshAfter,
  };
}
